export default __webpack_public_path__ + "d244b18413b9eaacf161305d2e84fa37.svg";